(function () {
    'use strict';

    function DataShareService() {

        var memory = [];

        var service = {
            setData: setData,
            getData: getData
        };

        return service;

        function setData(key, value) {
            memory[key] = value;
        }

        function getData(key) {
            var data = '';
            if (key in memory) {
                data = memory[key];
                delete memory[key];
            } 
            return data;
        }
    }

    module.exports = DataShareService;
})();